export default __webpack_public_path__ + "static/media/csv.af80538a.png";